import {SandboxTree} from 'yougile-model'
/**
 * API script running context
 */
export class Context {
  public box: SandboxTree
  public scriptName: string
  public extensionId: string | undefined

  constructor(
    box: SandboxTree,
    scriptName: string,
    extensionId: string | undefined
  ) {
    this.box = box
    this.scriptName = scriptName
    this.extensionId = extensionId
  }
}
